/**
 * What the trainee drank, against what the menu asked for.
 *
 * `water_ml` has been a column on the day log all along; the coach endpoint simply did not carry it,
 * so this is new information rather than a new field. Hidden entirely when the menu sets no goal AND
 * the trainee logged nothing — there is no fact to report, and an empty card reads as a missing
 * feature. A goal with zero drunk is worth showing: that IS the fact.
 */

import Box from "@mui/material/Box";
import LocalDrinkOutlinedIcon from "@mui/icons-material/LocalDrinkOutlined";
import { num } from "../ui/format";
import { v2 } from "../ui/v2Tokens";

const nums = { unicodeBidi: "isolate", direction: "ltr" as const, display: "inline-block" };

export const DayWaterCard = ({ waterMl, goalMl }: { waterMl: number; goalMl?: number }) => {
  const goal = goalMl && goalMl > 0 ? goalMl : 0;
  if (!goal && !waterMl) return null;

  const pct = goal ? Math.min(100, Math.round((waterMl / goal) * 100)) : 0;

  return (
    <Box
      data-testid="log-water"
      sx={{
        backgroundColor: v2.surface,
        border: `1px solid ${v2.line}`,
        borderRadius: "14px",
        p: 1.5,
        mb: 1.25,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <LocalDrinkOutlinedIcon sx={{ fontSize: 18, color: v2.under }} />
        <Box sx={{ fontSize: 13.5, fontWeight: 700, color: v2.ink }}>מים</Box>
        <Box sx={{ flex: 1 }} />
        <Box sx={{ fontSize: 12.5, color: waterMl ? v2.ink2 : v2.ink4 }}>
          {waterMl ? (
            <>
              <Box component="span" sx={nums}>
                {num(waterMl)}
              </Box>{" "}
              מ״ל
              {goal ? (
                <>
                  {" "}
                  מתוך{" "}
                  <Box component="span" sx={nums}>
                    {num(goal)}
                  </Box>{" "}
                  מ״ל
                </>
              ) : null}
            </>
          ) : (
            "לא דווחה שתייה"
          )}
        </Box>
      </Box>

      {goal ? (
        <Box sx={{ mt: 1, height: 6, borderRadius: 3, backgroundColor: v2.lineSoft, overflow: "hidden" }}>
          <Box sx={{ width: `${pct}%`, height: "100%", backgroundColor: v2.under }} />
        </Box>
      ) : null}
    </Box>
  );
};
